












































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SearchForm from '@/components/common/SearchForm.vue'
import TableForm from '@/components/common/TableForm.vue'
import { translate ,DateTime } from '@/utils/filters'
import { businessParamMap } from '@/utils/status-map'
import GenerateReturnCodeDialog from './GenerateReturnCodeDialog.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { Route } from 'vue-router'
import { Channel } from '@/api/model/channel'

@Component({
    components: {
        SearchForm,
        TableForm,
        GenerateReturnCodeDialog
    }
})
export default class OverseasPaymentReceipt extends Vue {
    searchForm: any = {
        current: 1,
        size: 10,
        mid: null,
        bizId: null,
        detailId: null,
        status: null,
        identity: null,
        realName: null,
        phone: null,
        repaymentCode: null,
        businessParam: null,
        channelId: null,
        createDate: []
    }
    statusOptions = [
        { id: 0, text: translate('chargeback.add') },
        { id: 1, text: translate('chargeback.deducting') },
        { id: 2, text: translate('chargeback.completeOfPart') },
        { id: 3, text: translate('chargeback.closed') },
        { id: 4, text: translate('chargeback.allCpmplete') },
        { id: 5, text: translate('chargeback.expireDate') },
        { id: 6, text: translate('chargeback.exception') }
    ]
    businessParamOptions = businessParamMap.createArray()
    channelList: any = []
    dateTime = DateTime
    tableLoading = false
    tableData = []
    total = 0

    showCreateDialog = false
    cameraId = ''
    showSearchForm = true
    totalAmount: any = 0

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    view(id: string) {
        const query = { id }
        const { from } = this.$route.query
        if (from === 'repayment-unpaid-record') {
            this.$router.push({ name: 'unpaid/repayment-detail', query })
        } else {
            this.$router.push({ name: 'receipt/repayment/detail', query })
        }
    }

    @Watch('searchForm.createDate')
    onCreateTimeChange(date: [Date, Date]): void {
        this.convertFormDate(date, ['createTimeStart', 'createTimeEnd'])
    }

    convertFormDate(date: [Date, Date], props: [string, string]) {
        const [startProp, endProp] = props
        this.searchForm[startProp] = null
        this.searchForm[endProp] = null
        if (date) {
            const [startDate, endDate] = date
            if (startDate) {
                this.searchForm[startProp] = startDate.getTime()
            }
            if (endDate) {
                this.searchForm[endProp] = endDate.getTime()
            }
        }
    }

    created() {
        const { cameraId, phone = '' } = this.$route.query
        if (cameraId) {
            this.searchForm.bizId = cameraId as any
            this.showSearchForm = false
        }
        this.searchForm.phone = phone
        this.getData()
        this.getChannelList()
    }

    getData(pageQuery = {}) {
        Object.assign(this.searchForm, pageQuery)
        const { createDate, ...params } = { ...this.searchForm }
        this.tableLoading = true

        // $Api.receiptService
        //     .abroadDeductListAmount(params)
        //     .subscribe(data => {
        //         this.totalAmount = data
        //     })
        $Api.receiptService
            .abroadDeductList(params)
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                data.list.map((item: any) => {
                    item.businessParamText = businessParamMap[item.businessParam]
                    return item
                })

                this.tableData = data.list
                this.total = data.total
            })
    }

    getChannelList() {
        $Api.channelService.queryChannelDropdown().subscribe(data => {
            this.channelList = data
        })
    }

    exportRepayment() {
        console.log('export')
        if (this.total > 10000) {
            this.$message.error('数据过多，请重新查询。')
        } else {
            $Api.receiptService.exportAbroadRePaymentList({ ...this.searchForm }).subscribe()
        }
    }

    /**
     * 生成返回码
     */
    createReturnCode(row: any) {
        this.cameraId = row.bizId
        this.showCreateDialog = true
    }

    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }
}
